// label 을 주면 이름만 바꿔 단다. 문제뱅크 줄이 "문제뱅크" 대신 종류(문법·단어...)를
// 달 때 쓴다. 색은 type 것을 그대로 쓴다.
const WorksheetTypeBox = ({ type, label }) => {
  const typeInfo = {
    analysis: {
      name: "지문분석 워크북",
      backgroundColor: "#E8F7EE",
      color: "#1DB05B",
    },
    comprehensive: {
      name: "내용이해 워크북",
      backgroundColor: "#FDF3E3", // [색 스왑] 학생 사이트와 통일 — 내용이해=오렌지
      color: "#E8920A",
    },
    paragraph: {
      name: "모의고사 유형",
      backgroundColor: "#FCEDE9",
      color: "#C2452D",
    },
    vocabulary: {
      name: "단어테스트",
      backgroundColor: "#E9EFF7",
      color: "#3E6398",
    },
    sentence: {
      name: "문장테스트",
      backgroundColor: "#FBF4D9",
      color: "#8A6D00",
    },
    grammar: {
      name: "어법",
      backgroundColor: "#EFEBFC", // [색 스왑] 학생 사이트와 통일 — 어법=보라
      color: "#6B4EE6",
    },
    bank: {
      name: "문제뱅크",
      backgroundColor: "#EFFBF8",
      color: "#00A396",
    },
    paper_assignment: {
      name: "지필과제",
      backgroundColor: "#F4F8F7",
      color: "#3A434E",
    },
  };

  if (!typeInfo[type]) return null;

  return (
    <div
      style={{
        backgroundColor: typeInfo[type].backgroundColor,
        color: typeInfo[type].color,
        borderRadius: "999px",
        padding: "3px 11px",
        fontSize: "0.73rem",
        fontWeight: 700,
        display: "inline-block",
        textAlign: "center",
        whiteSpace: "nowrap",
        flexShrink: 0,
      }}
    >
      {label || typeInfo[type].name}
    </div>
  );
};

export default WorksheetTypeBox;
